export default class SubventionNumberValidator {
    constructor(number) {
        this.number = number;
        this.sanitizedNumber = number.replaceAll(/\s/g, '');
        const regex = new RegExp('^(\\d{1,10})\\/(\\d{1,8})\\/(\\d{1,4})-(\\d)\\/(\\d)\\/(\\d)$');
        this.matches = this.sanitizedNumber.match(regex);
        if (this.matches === null) {
            return false;
        }
    }

    isValid() {
        return this.matches !== null && this.isValidChildCheckSum() && this.isValidApplicationCheckSum();
    }

    isValidApplicationCheckSum() {
        return this.matches !== null && this.checksum(this.matches[2]) === Number.parseInt(this.matches[5]);
    }

    isValidChildCheckSum() {
        return this.matches !== null && this.checksum(this.matches[1]) === Number.parseInt(this.matches[4]);
    }

    checksum(value) {
        let sum = 0;
        for (let i = 0; i < value.length; i++) {
            const factor = i % 2 === 0 ? 3 : 1;
            const position = value.length - 1 - i;
            sum += factor * Number.parseInt(value.charAt(position));
        }

        return sum % 10 === 0 ? 0 : 10 - sum % 10;
    }
}
